<div class="badge fx-row fx-layout-align-start-center" [dialogLink]="['notes', ticket.stationId, ticket.ticketId]">
    <!-- ticket icon -->
    <mat-icon [svgIcon]="'c-report'"></mat-icon>

    <!-- ticket info -->
    <div class="info fx-column fx-flex">
        <div class="fx-row fx-layout-align-space-between-center">
            <label>{{ ticket.title | ceCustomerPrivacy: 'station' }}</label>
            <mat-icon *ngIf="ticket.pinned" svgIcon="pin" class="pinned-badge"></mat-icon>
        </div>
        <div class="description">
            [{{ ticket.ref | ceCustomerPrivacy: 'randomNumber' }}]
            {{ ticket.description | ceCustomerPrivacy: 'person' }}
        </div>
    </div>
</div>
